import { render, staticRenderFns } from "./intent.vue?vue&type=template&id=57bc5e68&scoped=true"
import script from "./intent.vue?vue&type=script&lang=js"
export * from "./intent.vue?vue&type=script&lang=js"
import style0 from "./intent.vue?vue&type=style&index=0&id=57bc5e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc5e68",
  null
  
)

export default component.exports